import React from "react";
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';


const LearningSpaces = () =>{
  
  return (
    <div className="LearningSpace">
      <section className="inner-banner banner-align">
        <img className="img-fluid" src="/assets/img/innerbanner/Learning-Space-Computers-banner-image.jpg" alt=""/>
      </section>
      <section className='information-common' id="ExploreLibrary">
        <div className='container'>
              <div className='information-content'>
                <h2>Using the Library/Explore</h2>
                <p>The following collaborative spaces are available at the library.</p>
              </div>
          <div className="row">
            <div className="col-lg-12">
                <div className="collaboration-list">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="collaborative">
                      <Row>
                        <Col lg={5} sm={6}>
                          <div className="right-tab-collab">
                            {/* <h5>Collaborative Working and <br/> Learning Spaces</h5> */}
                            <Nav variant="pills" className="flex-column">
                              <Nav.Item>
                                <Nav.Link eventKey="collaborative" href="#">
                                Collaborative Working and Learning Spaces
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link eventKey="ctequipement" href="#">
                                Computer and Technology (Equipment)
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link eventKey="prinitingscanning" href="#">
                                Printing, Scanning and Photocopying
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link eventKey="libraryservice" href="#">
                                Library Services
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link eventKey="markerspace" href="#">
                                Maker Space
                                </Nav.Link>
                              </Nav.Item>
                              
                            </Nav>
                          </div>
                        </Col>
                        <Col lg={7} sm={6}>
                          <Tab.Content>
                            <Tab.Pane eventKey="collaborative">
                              <div className="collaboration-hover">
                                <img className="img-fluid" src="/assets/img/learningspaces/collaborative-image.jpg" alt=""/>
                                <h6>Information Commons</h6>
                                <p>Information commons located at the ground floor houses collaborative learning and socializing spaces including a lounge, media scape and group seating spaces. Makerspace for creative work and expression is also available at the library. Maker items including littlebits, snap circuits, 3D pen,  stationery, items for printing on curio printer etc. are issued to the students.</p>
                                <h6>Discussion Zone</h6>
                                <p>Opposite to front desk on first floor, discussion area is available for collaborative work and and discussion.</p>
                                <h6>One-on-one Study Zone</h6>
                                <p>For facilitating one-on-one study and discussion, study tables with chairs are available opposite to library offices.</p>
                                <h6>Discussion Rooms</h6>
                                <p>There are 7 discussion rooms equipped with LCD TVs for discussing projects and brainstorming innovative ideas. The discussion rooms can be reserved through first floor front desk counter on first come first serve basis. The guidelines and procedure for issuance of discussion rooms is available here.</p>
                                <h6>Dawood Habib Yohsin Hall</h6>
                                <p>For individual, quiet study and reflection, Yohsin Hall is available with a seating capacity for approximately 50 students.</p>
                              </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="ctequipement" id="twobox">
                              <div className="collaboration-hover">
                                <img className="img-fluid" src="/assets/img/learningspaces/equipment-space.png" alt=""/>
                                <h6>Computers and Technology</h6>
                                <p>The Library Information Commons has made 60 state-of-the-art all in one desktop computers available, equipped with essential productivity software and high-speed Wi-Fi internet connections. The computers are available for use on the ground and first floor. Patrons who bring their own laptops or digital devices can also access the Wi-Fi system by contacting the Help Desk on the ground floor.</p>
                                {/* <h6>MAC Computers</h6> */}
                                {/* <p>6 state-of-the-art Macintosh computers are available for multimedia publishing and processing on the first-floor library.</p> */}
                            </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="prinitingscanning">
                              <div className="collaboration-hover">
                                <img className="img-fluid" src="/assets/img/learningspaces/printing-space.png" alt=""/>
                                <p>Both floors are equipped with high-speed network Do It Yourself (DIY) printers with photocopying and scanning services. Printing and photocopying can be done by purchasing a scratch card from Habib Dukaan and using student ID or employee ID card.</p>
                                <p>HU community may request for the color printing, binding or scanning of relevant and important documents, marketing materials etc. through this service. A nominal fee is charged for color printing.</p>
                            </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="markerspace">
                              <div className="collaboration-hover">
                                <img className="img-fluid" src="/assets/img/learningspaces/marker-space.png" alt=""/>
                                <p>HU library and its spaces promote Do It Yourself (DIY) attitude towards learning. To promote interdisciplinary learning, innovation and collaboration, a maker space is available at the library. Maker equipment is provided for generating ideas and prototypes. Maker workshops are also organized for building skills. Apart from workshops, maker items and stationery are also issued to individual and groups of students for putting their creativity to work. </p>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="libraryservice">
                              <div className="collaboration-hover">
                                <img className="img-fluid" src="/assets/img/learningspaces/library-space.png" alt=""/>
                                <p>Habib University’s library team aims to provide students with adequate facilities for learning with passion. With a range of academic services available, it creates an environment that supports learning, teaching, and research. The library provides a stimulating user centred environment, learning spaces, and customer services supported by digital technologies.</p>
                                <a href="" className="btn-dfault">View All Library Services</a>
                            </div>
                            </Tab.Pane>
                          </Tab.Content>
                        </Col>
                      </Row>
                    </Tab.Container>


                 
                </div>
            </div>
          
          </div>
        </div>
      </section>

     
    </div>
  );
}
export default LearningSpaces;